import { defineMessages } from 'react-intl';

export const PIE_CHART_MESSAGES = defineMessages({
  downloadAsCsv: {
    id: '9JhiinIAmqWKBJae',
    defaultMessage: 'Download as CSV',
    description:
      'Text in a tooltip shown when hovering the "Download data" button in the pie chart toolbar',
  },
  invalidDataset: {
    id: 'qoM4Je2O4h920xx0',
    defaultMessage: 'No data can be displayed because the value is 0',
    description: 'Text displayed when the pie chart dataset is invalid',
  },
});
